/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 다이얼로그 홍보결과목록 > 관심표명자 생일 컴포넌트
 * 버전 : 1.0
 * 파일명 : DialogInterestBirthday.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-07-17
 * ================================================================ 

 *================================================================
 */

import styled from 'styled-components'
import { NextButton, NextButtonWrapper } from '../common/CommonStyled'
import { LoadPromoInterest } from './useSubmitPromoFilter'
import { useState } from 'react'
import DateRangePickerInterestDialogBirth from './DateRangePickerInterestDialogBirth'
import { usePromoDialogInterest } from 'src/stores/PromoStore'

const PageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 80px;
    
    padding: 20px 24px;
`

const TitleWrapper = styled.span`
    font-size:16px;
    font-weight:500;
`
interface Props{
  result_id:number,
  school_class:string
}

const DialogInterestBirthday = ({result_id,school_class}:Props) => {
    const setField = usePromoDialogInterest((state)=>state.setField)
    const [resetTrigger,setResetTrigger] = useState(0)
    const temp_startBirth = usePromoDialogInterest((state)=>state.temp_startBirth)
    const temp_endBirth = usePromoDialogInterest((state)=>state.temp_endBirth)
    const handleSubmit = async () => {
        await setField('startBirth',temp_startBirth)
        await setField('endBirth',temp_endBirth)
        LoadPromoInterest(result_id,school_class)
    }
    const onClickReset = ()=>{
        setResetTrigger((prev)=>prev+1)
    }
  return (
    <PageWrapper>
        <TitleWrapper>
            생년월일
        </TitleWrapper>
        <DateRangePickerInterestDialogBirth resetTrigger={resetTrigger}/>
        <NextButtonWrapper $isBorder={false}>
            <NextButton style={{background:'#F5F5F5', color:'#7F7F89', minWidth:'90px', width:'90px', boxShadow:'none', border:'1px solid #00001480'}} onClick={onClickReset}>초기화</NextButton>
            <NextButton onClick={handleSubmit} style={{margin:'5px',padding:'10px', height:'46px', boxShadow:'none'}}>적용</NextButton>
        </NextButtonWrapper>
    </PageWrapper>
)
}

export default DialogInterestBirthday